
import { createStore, applyMiddleware } from 'redux';

import { persistStore, persistReducer } from 'redux-persist';

import createSagaMiddleware from 'redux-saga';

import rootReducer from './reducers';

import { rootSaga } from './sagas';

import { keepAlive } from './sagaUtils';

import storage from 'redux-persist/lib/storage';

// Only persist what the server session does not own. Cart and wishlist are
// re-fetched via common content on load (Layout -> CcommonContent_sync) and the
// auth user is re-fetched via CCheckAuth_sync (Header). `auth` is NOT listed
// here: it has its own nested persist config in reducers.js that keeps only
// `isAuthenticated` (listing it here would persist the full auth state again).
const persistConfig = {
  key: 'sg-v3',
  version: 3,
  storage,
  whitelist: [
    'recentlyViewedProducts',
    'languages',
  ],
};

// One-time cleanup of old Redux Persist storage.
// `persist:root` contained large/stale API page data; `persist:sg-v2` contained
// the full auth state (customer PII), cart and wishlist.
try {
  ['persist:root', 'persist:sg-v2'].forEach((oldKey) => {
    if (localStorage.getItem(oldKey) !== null) {
      localStorage.removeItem(oldKey);
    }
  });
} catch (error) {
  console.warn('Unable to clean old Redux Persist storage:', error);
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  persistedReducer,
  applyMiddleware(sagaMiddleware)
);

sagaMiddleware.run(rootSaga);

// Route sagas are injected once, before their page component is rendered.
// Keeping the registry on the store prevents duplicate watchers when users
// navigate away from a route and return to it.
const injectedSagas = new Map();

store.injectSaga = (key, saga) => {
  const existingTask = injectedSagas.get(key);
  if (existingTask && existingTask.isRunning()) {
    return existingTask;
  }

  const task = sagaMiddleware.run(keepAlive(saga));
  injectedSagas.set(key, task);
  return task;
};

const persistor = persistStore(store);

export { store, persistor };

